"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.budgetSpiClient = void 0;
require("@redbox-ruby/data-lib");
const data_lib_1 = require("@redbox-ruby/data-lib");
function budgetSpiClient(networkClient) {
    return {
        sendAllocateBudget: (message) => {
            networkClient.fireToTopic(data_lib_1.ALLOCATE_BUDGET_TOPIC, message, "Unable to allocate notification message, error=");
        },
        createBudgetAllocation: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/spi/v2/budgets/campaigns/${params.campaignId}/allocations`, body);
        },
        payArrearsOrder: async (params, body) => {
            return networkClient.postHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/spi/v2/budgets/teams/${params.teamId}/orders/arrears`, body);
        },
        createOrUpdateDraftArrearsOrder: async (params, body) => {
            return networkClient.putHttp(data_lib_1.BUDGETS_WEB_SERVICE, `/spi/v2/budgets/teams/${params.teamId}/orders/arrears`, body);
        },
    };
}
exports.budgetSpiClient = budgetSpiClient;
